 <template>
  <router-link :to="{ name: 'Course', params: {id: course.id} }" class="course-card" :class="{ lastCall: isLastCall, bookmarked: isBookmarked }">
    <article class="d-flex flex-column bg-white fs-13 p-3 h-100">
      <h3 class="h6 ms-n3">{{ course.title }}</h3>
      <div class="d-flex flex-column w-100">
        <div class="d-flex">
          <span class="material-icons-rounded iconMeta">place</span>
          <p class="mb-2">{{ course?.venueCity }}, {{ course.venueCountry }}</p>
        </div>
        <div class="d-flex align-items-start">
          <span class="material-icons-rounded iconMeta">date_range</span>
          <p class="mb-2">{{ formatDate(course.dateFrom) }} - {{ formatDate(course.dateTo) }}
            <span class="ps-1 ps-xl-3" :class="{ 'text-warning' : isLastCall }" >
              <span class="material-icons-rounded fs-16 me-1">alarm</span><span>{{ formatDate(course.deadline) }}</span>
            </span>
          </p>
        </div>
        <div class="d-flex">
          <span class="material-icons-rounded iconMeta">school</span>
          <div class="">
            <p class="mb-2">
              {{ course.provider?.name }} <span v-if="course.provider?.compartmentName">({{ course.provider?.compartmentName }})</span>
              <span v-if="course.otherTrainingInstitutions.length > 0">, </span>
              <span v-for="(item, index) in course.otherTrainingInstitutions" :key="index">
                {{ item.name }} <span v-if="item.compartmentName">({{ item?.compartmentName }})</span>
                <span v-if="index+1 < course.otherTrainingInstitutions.length">, </span>
              </span>
            </p>
          </div>
        </div>
        <div class="d-flex" v-if="course.network">
          <span class="material-icons-rounded iconMeta">hub</span>
          <p class="mb-0">{{ course.network?.name }}</p>
        </div>
      </div>
      <div class="d-flex justify-content-end mt-auto pt-2">
        <a href="#" class="btn-card mt-n2 me-2" v-tooltip.top="'Share by email'" @click.prevent="shareCourse" >
          <span class="material-icons-rounded">forward_to_inbox</span>
        </a>
        <a href="#" v-if="isBookmarked" @click.prevent="bookmarkThisCourse"
          class="btn-card mt-n2 me-2"
          v-tooltip.top="'Remove from bookmarks'">
          <span class="material-icons-rounded text-primary">bookmark</span>
        </a>
        <a href="#" v-else @click.prevent="bookmarkThisCourse"
           class="btn-card mt-n2 me-2"
           v-tooltip.top="'Bookmark this course'">
          <span class="material-icons-rounded">bookmark_border</span>
        </a>
      </div>
    </article>
  </router-link>
</template>

<script setup lang="ts">
import {ref} from "vue"
import {formatDate, getEncodedBody, isCourseBookmarked, toggleBookmark} from "@/views/course/CourseUtils"
import axios from "axios";
import {CourseShared} from "@/types/CourseShared";

const props = defineProps(["course"]);
  const emit = defineEmits(["bookmark"]); //TODO!

  const isBookmarked = ref(isCourseBookmarked(props.course.id));

  const today = new Date( new Date().getTime());
  today.setTime(today.setHours(0,0,0, 0));
  const deadline = new Date( new Date(props.course.deadline).getTime() );
  deadline.setTime(deadline.setHours(0,0,0, 0));
  const isLastCall = ref( today.getTime() >=  new Date (deadline.getTime() - (14*24*60*60*1000) ).getTime() );

  function bookmarkThisCourse() {
    isBookmarked.value = toggleBookmark(props.course.id);
    emit("bookmark");
  }

  async function shareCourse() {
    const courseResp = await axios.get("api/course/" + props.course.id + "/share");
    if (courseResp.status == 200 && courseResp.data != null) {
      const courseShared: CourseShared = CourseShared.fromResponse(courseResp.data);
      const encodedSubject = encodeURIComponent("CSDP Training Programme: " + (courseShared.title ?? ''));
      const encodedBody = getEncodedBody(courseShared);
      window.location.replace(`mailto:?subject=${encodedSubject}&body=${encodedBody}`);
    }
  }

</script>


<style lang="scss" scoped>

a.course-card {
  text-decoration: none;
  color: #424242;
  &:hover .h6 {
    color: #1976d2;
  }
}

article {
  box-shadow: 0 1px 1px #0000001a,0 2px 2px #0000001a!important;
  transition: all .3s ease-in-out;

  a.btn-card {
    color: #b2dedb;
    padding: 0.5rem .75rem;
    border-radius: 4px;
  }
  &:hover {
    box-shadow: #0003 0 5px 20px!important;
    cursor: pointer;
    h6 {
      color: #1976d2;
    }
    a.btn-card {
      color: #8dceca;
      &:hover {
        background-color: #ECF6FF;
        color: #1976d2;
      }
    }
  }
  .h6 {
    line-height: 1.4;
    position: relative;
    border-left: 5px solid transparent;
    padding-left: 10px;
    margin: 0 15px 15px 0;
    width: calc(100% + 0px);
  }
  &.lastCall .h6 {
    border-left: 5px solid #ffc107;
  }
  &.bookmarked .h6 {
    border-left: 5px solid #1976d2;
  }
  &.bookmarked.lastCall .h6 {
    border-left: 5px solid #ffc107;
  }
}

.iconMeta {
  font-size: 16px;
  width: 16px;
  text-align: center;
  margin-right: .75rem;
  color: #b2dedb;
}


@media screen and (min-width: 769px) {
  .lastCall h6::after,
  .bookmarked h6::after {
    left: -16px;
  }
  h6 {
    margin: 0 16px 15px 0;
  }
}
</style>